<template>
    <div class="animated fadeIn">
        <BaseInventory
            categoryId="9"
            categoryName="Gas Separator"
            categorySectionIcon="fa-wrench"
        />
    </div>
</template>

<script>
import BaseInventory from './base/BaseInventory'

export default {
    name: 'gas-separator',
    components: { BaseInventory }
}
</script>
